module.exports = __webpack_public_path__ + "img/book.939a7217.svg";